// src/services/loginService.js
import axios from "../config/axiosConfig";
import ENV from "../config/env";

// Ajusta la ruta si tu PHP está en subcarpeta:
// const SYNC_REFRESH_URL = "/sort/embed/sync_refresh.php";
const SYNC_REFRESH_URL = ENV.PHP_SORT_SERVIDOR + "/files/sync_refresh.php";

// Helper para enviar el refresh_token a la sesión PHP
async function syncRefreshToPhp(refreshToken) {
  if (!refreshToken) return;
  try {
    await fetch(SYNC_REFRESH_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      // MUY IMPORTANTE: envía/recibe la cookie de sesión PHP (PHPSESSID)
      credentials: "include",
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
  } catch (e) {
    // No rompemos el login si falla el sync; solo avisamos en consola
    console.warn(
      "No se pudo sincronizar refresh_token con PHP:",
      e?.message || e
    );
  }
}

const loginService = {
  login: async ({ username, password, rememberMe }) => {
    try {
      // 👇 ESTA es tu ruta original, la dejo igual
      const response = await axios.post("/api/auth/login", {
        username,
        password,
        rememberMe,
      });

      // Tu backend manda estos nombres:
      const token = response.data.token;
      const refreshToken = response.data.refresh_token;

      // 👉 ESTA parte te faltaba: guardarlo para que axiosConfig lo use
      if (token) {
        localStorage.setItem("token", token);
      }
      if (refreshToken) {
        localStorage.setItem("refreshToken", refreshToken);
        // y ya que lo tenías, lo sincronizamos al PHP
        await syncRefreshToPhp(refreshToken);
      }

      // devolvemos algo útil a tu useLogin
      return { token, refreshToken, ...response.data };
    } catch (error) {
      // Si el backend respondió (credenciales incorrectas, etc.) usamos ese
      // mensaje; si no hubo respuesta (servidor caído, sin red) lo decimos.
      const backendMessage = error?.response?.data?.error;
      throw new Error(backendMessage || "No se pudo conectar con el servidor.");
    }
  },
};

export default loginService;
